import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AppPaths } from '../routes/app-paths';
import { AuthStore } from '@features/auth/auth.store';

/**
 * Guard that checks if a user is NOT authenticated
 * Redirects to dashboard if already authenticated
 * Used for public routes like login and register
 */
export const publicGuard: CanActivateFn = (_route, _state) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  // Check if user is authenticated
  const isAuthenticated = authStore.isAuthenticated();

  if (isAuthenticated) {
    // User is authenticated, redirect to jobs (default page)
    router.navigate([AppPaths.JOBS]);
    return false;
  }

  return true;
};
